<script lang="ts" setup>
import type { EsProductFragment } from '#graphql-operations'
import type { DataLayerItem } from '~layers/composables/useDataLayer'
import { AppLink } from '#components'

const props = withDefaults(defineProps<{
  product: EsProductFragment
  list?: string
  parameter?: string
  dataLayerOverrides?: Partial<DataLayerItem>
}>(), {
  list: 'other',
  parameter: '',
  dataLayerOverrides: undefined,
})

const { product } = toRefs(props)

const hover = ref(false)

const imageSrc = computed(() => {
  let imageSrc = product.value.image

  if (hover.value && product.value.hover_image) {
    imageSrc = product.value.hover_image
  }

  return useXcdnImage(imageSrc, 'f=rs:fit:400:400', product.value.name)
})

const prices = computed(() => {
  if (product.value.fromPrice) {
    return {
      regularPrice: product.value.fromPrice,
      finalPrice: product.value.fromPrice,
    }
  }
  return {
    regularPrice: product.value.regularPrice,
    finalPrice: product.value.finalPrice,
  }
})

function mouseOver() {
  hover.value = true
}

function mouseOut() {
  hover.value = false
}

const emit = defineEmits(['productClick'])
const { selectItem } = useDataLayer()

const trackProductClick = ({ product, dataLayerOverrides }: { product: EsProductFragment, dataLayerOverrides: Record<string, unknown> }) => {
  selectItem(product, dataLayerOverrides)
  emit('productClick', product)
}
</script>

<template>
  <article
    v-if="product"
    class="product-search"
  >
    <div class="product-search__details">
      <UiHeading class="product-search__heading">
        <AppLink
          :to="`${product.url}${parameter}`"
          class="product-search__link"
          :class="{ 'sqzl-click': product?.squeezely }"
          :data-sqzl-personalization-id="product?.squeezely?.personalizationId"
          :data-sqzl-variant-id="product?.squeezely?.variantId"
          :data-sqzl-variant-revision="product?.squeezely?.variantRevision"
          @click="trackProductClick({ product: product, dataLayerOverrides: dataLayerOverrides })"
          @mouseover="mouseOver"
          @mouseout="mouseOut"
        >
          <span class="product-search__name">{{ product.mainTitle }}</span>
        </AppLink>
      </UiHeading>

      <span class="product-search__description">
        {{ product.subTitle }}
      </span>

      <UiPrice
        class="product-search__price"
        :prices="prices"
      >
        <!-- <template
          v-if="product.fromPrice"
          #prefix
        >
          v.a.
        </template> -->
      </UiPrice>

      <!--
      <UiPrice
        class="product-search__price"
        :prices="{
          regularPrice: product.regularPrice,
          // finalPrice: product.finalPrice,
        }"
      />
      -->

      <!--
      <ProductColorVariant
        v-if="product?.relatedColorProducts?.length"
        :color-variants="product.relatedColorProducts"
        class="product-search__color-variants"
      />
      -->
    </div>

    <div class="product-search__labels">
      <ProductLabelSale
        v-if="product.isSale"
        :prices="prices"
      />

      <!-- <ProductLabelMarketing :product="product" /> -->
    </div>

    <!-- <ProductToggleWishlist
      class="product-search__wishlist"
      :product="product"
    /> -->

    <div class="product-search__visual">
      <img
        class="product-search__image"
        :src="imageSrc"
        width="400"
        height="400"
        loading="lazy"
        :alt="product.name"
      >
    </div>
    <!-- <pre>{{ product }}</pre> -->
  </article>
</template>

<style>
@import url("~layers/components/Search/ProductTile.css");
</style>
